export default function setupVolumeSaving(
  player,
  { localStorageKey = 'bbcm-volume' } = {}
) {
  const savedVolume = localStorage.getItem(localStorageKey);
  if (savedVolume) {
    player.volume(parseFloat(savedVolume));
  }
  player.on('volumechange', function() {
    localStorage.setItem(localStorageKey, player.volume());
  });
}
